"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationAction_1 = require("../models/NavigationAction");
var KEY_TO_ACTION = {
    '33': NavigationAction_1.Action.PrevView,
    '34': NavigationAction_1.Action.NextView,
    '35': NavigationAction_1.Action.LastInView,
    '36': NavigationAction_1.Action.FirstInView,
    '37': NavigationAction_1.Action.Left,
    '38': NavigationAction_1.Action.Up,
    '39': NavigationAction_1.Action.Right,
    '40': NavigationAction_1.Action.Down,
    'meta+38': NavigationAction_1.Action.UpperView,
    'meta+40': NavigationAction_1.Action.LowerView
};
/**
 * @hidden
 */
var NavigationService = /** @class */ (function () {
    function NavigationService(bus) {
        this.bus = bus;
    }
    NavigationService.prototype.action = function (event) {
        var action = "" + (event.ctrlKey || event.metaKey ? 'meta+' : '') + event.keyCode;
        return KEY_TO_ACTION[action];
    };
    NavigationService.prototype.move = function (value, action, activeView, service, event) {
        if (!service) {
            return value;
        }
        if (action === NavigationAction_1.Action.UpperView && this.bus.canMoveUp(activeView)) {
            this.bus.moveUp(activeView, event);
            return value;
        }
        if (action === NavigationAction_1.Action.LowerView && this.bus.canMoveDown(activeView)) {
            this.bus.moveDown(activeView, event);
            return value;
        }
        return service.move(value, action);
    };
    return NavigationService;
}());
exports.NavigationService = NavigationService;
//# sourceMappingURL=NavigationService.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/calendar/services/NavigationService.js
// module id = 6511
// module chunks = 0